// src/Pages/Selections/AddSelection.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useCreateSelectionMutation } from "../../redux/services/selectionsService/selections.Services";
import { useGetWaadDropdownQuery } from "../../redux/services/waadService/waad.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { FaArrowLeft, FaSave, FaImage } from "react-icons/fa";

function AddSelection() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [createSelection, { isLoading }] = useCreateSelectionMutation();
  const { data: waadData, isLoading: waadLoading } = useGetWaadDropdownQuery();

  const [formData, setFormData] = useState({
    type: "sports",
    waad_id: "",
    waad_name: "",
    member_name: "",
    father_name: "",
    mother_name: "",
    mobile: "",
    email: "",
    address: "",
    date_of_birth: "",
    gender: "male",
    // Sports fields
    sport_name: "",
    sport_category: "",
    sport_level: "",
    achievement: "",
    selection_date: "",
    // Govt Job fields
    job_type: "",
    job_department: "",
    job_designation: "",
    job_level: "",
    joining_date: "",
  });

  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.waad_id) {
      errorToast("Please select a waad");
      return;
    }

    if (!formData.member_name) {
      errorToast("Member name is required");
      return;
    }

    if (!formData.mobile) {
      errorToast("Mobile number is required");
      return;
    }

    // Sports validation
    if (formData.type === "sports" && !formData.sport_name) {
      errorToast("Sport name is required");
      return;
    }

    // Govt Job validation
    if (formData.type === "govt_job" && !formData.job_department) {
      errorToast("Job department is required");
      return;
    }

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== "") {
          formDataToSend.append(key, formData[key]);
        }
      });
      if (image) {
        formDataToSend.append("image", image);
      }

      const response = await createSelection(formDataToSend).unwrap();
      successToast(response?.message || "Selection created successfully");
      navigate("/selections");
    } catch (error) {
      console.error("Create selection error:", error);
      errorToast(error?.data?.message || "Failed to create selection");
    }
  };

  return (
    <div className="selections-page">
      {/* Header */}
      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">Add Selection</h4>
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item active">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/selections">Selections</Link>
              </li>
              <li className="breadcrumb-item">Add Selection</li>
            </ol>
          </nav>
        </div>
        <div className="page-title fw-semibold fs-18 mb-0">
          <button className="btn btn-primary" onClick={() => navigate("/selections")}>
            <FaArrowLeft className="me-2" /> Back to List
          </button>
        </div>
      </div>

      {/* Form */}
      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* Type Selection */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">
                    Type <span className="text-danger">*</span>
                  </label>
                  <select
                    name="type"
                    className="form-control"
                    value={formData.type}
                    onChange={handleChange}
                  >
                    <option value="sports">Sports</option>
                    <option value="govt_job">Government Job</option>
                  </select>
                </div>
              </div>

              {/* Waad */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">
                    Waad <span className="text-danger">*</span>
                  </label>
                  <select
                    name="waad_id"
                    className="form-control"
                    value={formData.waad_id}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Waad</option>
                    {waadData?.data?.map((waad) => (
                      <option key={waad.id} value={waad.id}>
                        {waad.waad_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Member Name */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">
                    Member Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="member_name"
                    className="form-control"
                    placeholder="Enter member name"
                    value={formData.member_name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              {/* Father Name */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">Father Name</label>
                  <input
                    type="text"
                    name="father_name"
                    className="form-control"
                    placeholder="Enter father name"
                    value={formData.father_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Mother Name */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">Mother Name</label>
                  <input
                    type="text"
                    name="mother_name"
                    className="form-control"
                    placeholder="Enter mother name"
                    value={formData.mother_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Mobile */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">
                    Mobile <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="mobile"
                    className="form-control"
                    placeholder="Enter mobile number"
                    value={formData.mobile}
                    onChange={handleChange}
                    maxLength="10"
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* DOB */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">Date of Birth</label>
                  <input
                    type="date"
                    name="date_of_birth"
                    className="form-control"
                    value={formData.date_of_birth}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Gender */}
              <div className="col-md-6">
                <div className="form-group">
                  <label className="fw-semibold">Gender</label>
                  <select
                    name="gender"
                    className="form-control"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>

              {/* Address */}
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fw-semibold">Address</label>
                  <textarea
                    name="address"
                    className="form-control"
                    rows="2"
                    placeholder="Enter address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* ============================ */}
              {/* SPORTS FIELDS */}
              {/* ============================ */}
              {formData.type === "sports" && (
                <>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">
                        Sport Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="sport_name"
                        className="form-control"
                        placeholder="Enter sport name"
                        value={formData.sport_name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Sport Category</label>
                      <select
                        name="sport_category"
                        className="form-control"
                        value={formData.sport_category}
                        onChange={handleChange}
                      >
                        <option value="">Select Category</option>
                        <option value="Individual">Individual</option>
                        <option value="Team">Team</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Sport Level</label>
                      <select
                        name="sport_level"
                        className="form-control"
                        value={formData.sport_level}
                        onChange={handleChange}
                      >
                        <option value="">Select Level</option>
                        <option value="District">District</option>
                        <option value="State">State</option>
                        <option value="National">National</option>
                        <option value="International">International</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Achievement</label>
                      <input
                        type="text"
                        name="achievement"
                        className="form-control"
                        placeholder="Enter achievement"
                        value={formData.achievement}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Selection Date</label>
                      <input
                        type="date"
                        name="selection_date"
                        className="form-control"
                        value={formData.selection_date}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* ============================ */}
              {/* GOVT JOB FIELDS */}
              {/* ============================ */}
              {formData.type === "govt_job" && (
                <>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">
                        Job Type <span className="text-danger">*</span>
                      </label>
                      <select
                        name="job_type"
                        className="form-control"
                        value={formData.job_type}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Job Type</option>
                        <option value="Central Govt">Central Govt</option>
                        <option value="State Govt">State Govt</option>
                        <option value="PSU">PSU</option>
                        <option value="Others">Others</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">
                        Job Department <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="job_department"
                        className="form-control"
                        placeholder="Enter job department"
                        value={formData.job_department}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Job Designation</label>
                      <input
                        type="text"
                        name="job_designation"
                        className="form-control"
                        placeholder="Enter job designation"
                        value={formData.job_designation}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Job Level</label>
                      <select
                        name="job_level"
                        className="form-control"
                        value={formData.job_level}
                        onChange={handleChange}
                      >
                        <option value="">Select Job Level</option>
                        <option value="Group A">Group A</option>
                        <option value="Group B">Group B</option>
                        <option value="Group C">Group C</option>
                        <option value="Group D">Group D</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Selection Date</label>
                      <input
                        type="date"
                        name="selection_date"
                        className="form-control"
                        value={formData.selection_date}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label className="fw-semibold">Joining Date</label>
                      <input
                        type="date"
                        name="joining_date"
                        className="form-control"
                        value={formData.joining_date}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </>
              )}

              {/* Image Upload */}
              <div className="col-md-12">
                <div className="form-group">
                  <label className="fw-semibold">Image</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  {imagePreview && (
                    <div className="mt-2">
                      <img
                        src={imagePreview}
                        alt="Preview"
                        style={{ width: "150px", height: "150px", objectFit: "cover", borderRadius: "8px" }}
                      />
                    </div>
                  )}
                </div>
              </div>

              {/* Submit Buttons */}
              <div className="col-md-12 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Creating...
                    </>
                  ) : (
                    <>
                      <FaSave className="me-2" /> Submit
                    </>
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ms-2"
                  onClick={() => navigate("/selections")}
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddSelection;